import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { FlagGbIcon, FlagKzIcon, FlagRuIcon, FlagUzIcon } from '@/shared/ui/icons';
import type { IconProps } from '@/shared/ui/icons';

export type LanguageCode = 'uz' | 'ru' | 'en' | 'kk';

export type Language = { code: LanguageCode; native: string; Flag: ComponentType<IconProps> };

export const LANGUAGES: Language[] = [
  { code: 'uz', native: "O'zbekcha", Flag: FlagUzIcon },
  { code: 'ru', native: 'Русский', Flag: FlagRuIcon },
  { code: 'en', native: 'English', Flag: FlagGbIcon },
  { code: 'kk', native: 'Қазақша', Flag: FlagKzIcon },
];

const DEFAULT_LANGUAGE: Language = { code: 'uz', native: "O'zbekcha", Flag: FlagUzIcon };

export const useCurrentLanguage = (): Language => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language ?? 'uz').slice(0, 2);
  return LANGUAGES.find((l) => l.code === current) ?? DEFAULT_LANGUAGE;
};
